const STORAGE_KEY = 'shipspan_admin_first_login_pw';

export interface FirstLoginPasswordSession {
  token: string;
  email: string;
  portalType: 'admin';
}

export function storeFirstLoginPasswordSession(session: FirstLoginPasswordSession) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function readFirstLoginPasswordSession(): FirstLoginPasswordSession | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as FirstLoginPasswordSession;
    if (!parsed?.token || !parsed?.email) return null;
    return { ...parsed, portalType: 'admin' };
  } catch {
    return null;
  }
}

export function clearFirstLoginPasswordSession() {
  sessionStorage.removeItem(STORAGE_KEY);
}
